<template>
  <Table :rows="list" :columns="columns" :columnID="'id'" :containerClass="'m-0'">
    <template #headactions>
      <button class="btn btn-xs btn-icon btn-light-success" @click="onNew">
        <i class="fa fa-plus"></i>
      </button>
    </template>
    <template #rows="{ rows }">
      <PrivadoLiquidarRow v-for="row in rows" :key="row.id" :item="row"></PrivadoLiquidarRow>
      <tr class="table-secondary" v-for="(val, moneda) in total" :key="moneda">
        <td :colspan="!estaLiquidado ? 6 : 5" class="text-right">
          <strong>TOTAL {{ moneda }}</strong>
        </td>
        <td class="text-center">{{ val | number(2) }}</td>
        <td></td>
      </tr>
    </template>
  </Table>
</template>

<script>
import PrivadoLiquidarRow from "./PrivadoLiquidarRow.vue";
import Table from "../../shared/components/Table.vue";
import { mapState, mapGetters } from "vuex";
export default {
  components: { Table, PrivadoLiquidarRow },
  computed: {
    columns() {
      let columns = [
        {
          key: "fecha",
          label: "Fecha",
          width: this.hayNuevos ? 85 : 60,
          head_class: "text-center",
        },
        {
          key: "servicio",
        },
        {
          key: "hotel",
          width: 250,
        },
        {
          key: "servicioTipo",
          label: "Tipo",
          width: 50,
          head_class: "text-center",
        },
        {
          key: "moneda",
          label: "Moneda",
          width: 60,
          head_class: "text-center",
        },
        {
          key: "tarifa",
          label: "Monto",
          width: 60,
          head_class: "text-center",
        },
        {
          key: "observaciones",
        },
      ];

      if (!this.estaLiquidado) {
        columns.unshift({
          key: "actions",
          label: "",
          width: 35,
          head_class: "text-center",
        });
      }

      return columns;
    },
    ...mapState("privado.liquidar", ["list"]),
    ...mapGetters("privado.liquidar", ["total", "estaLiquidado", "hayNuevos"]),
  },
  methods: {
    onNew() {
      this.$store.commit("privado.liquidar/new");
    },
  },
};
</script>

<style></style>
